const EMAIL_PREFERENCE_CATEGORY = Object.freeze({
  newsletter: 'NEWSLETTER',
  surveyBestPractices: 'SURVEY_BEST_PRACTICES',
  dataStories: 'DATA_STORIES',
  customerOpportunities: 'CUSTOMER_OPPORTUNITIES',
  purchaseInquiries: 'PURCHASE_INQUIRIES',
  productResearch: 'PRODUCT_RESEARCH',
});

export default EMAIL_PREFERENCE_CATEGORY;
